import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { pageUrl } from '@/constants/url'

const SalesPage = lazy(() => import('./pages/sales'))
const AllSalesPage = lazy(() => import('./pages/allSales'))
const InvoicePage = lazy(() => import('./pages/invoicePage'))

export const salesRoutes = () => {
  return (
    <>
      <Route path={pageUrl.sales} element={<SalesPage />} />
      <Route path={pageUrl.salesAll} element={<AllSalesPage />} />
    </>
  )
}

export const salesPublicRoutes = () => {
  return (
    <>
      <Route path={pageUrl.salesInvoice} element={<InvoicePage />} />
    </>
  )
}
